module.exports = __webpack_public_path__ + "static/media/destiny.db097fd2.png";